export default "__VITE_ASSET__BGBhH7Np__"